/* @flow */
/**
 * Created by Ondra on 10.11.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {openCreditListUser, fetchHabitueList, cleanHabitueList, doCredit} from '../../common/creditBill/actions';
import Currency from '../components/numbers/Currency';
import CloseButton from '../components/buttons/CloseButton';
import ArrLeftButton from '../components/buttons/ArrLeftButton';
import ArrRightButton from '../components/buttons/ArrRightButton';

class UsersPopup extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        fetchHabitueList: React.PropTypes.func,
        doCredit: React.PropTypes.func,
        cleanHabitueList: React.PropTypes.func,
        openCreditListUser: React.PropTypes.func,
        habitues: React.PropTypes.object,
        tables: React.PropTypes.object,
        tableToCredit: React.PropTypes.string,
        barId: React.PropTypes.number,
        page: React.PropTypes.number,
        limit: React.PropTypes.number,
        max: React.PropTypes.number
    };

    constructor(props) {
        super(props);

        this.doCredit = this.doCredit.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.prevPage = this.prevPage.bind(this);
    }

    componentWillMount() {
        const {fetchHabitueList, limit, page} = this.props;
        fetchHabitueList(limit, page);
    }

    componentWillUnmount() {
        const {cleanHabitueList} = this.props;
        cleanHabitueList();
    }

    doCredit(userId) {
        const {doCredit, tableToCredit, barId, tables} = this.props;

        const items = tables.getIn([tableToCredit, 'products']);
        const title = tables.getIn([tableToCredit, 'name']);

        doCredit(userId, barId, title, items);
    }

    nextPage() {
        const {fetchHabitueList, limit, page} = this.props;
        fetchHabitueList(limit, page + 1);
    }

    prevPage() {
        const {fetchHabitueList, limit, page} = this.props;
        fetchHabitueList(limit, page - 1);
    }

    render() {
        const {openCreditListUser, habitues, max, page, limit, tables, tableToCredit, msg} = this.props;
        const amount = tables.getIn([tableToCredit, 'totalPriceVat']);

        return (
            <div>
                <div id="bills-list" className="pageTables with-header">
                    <div className="pageTables-controls view-top">
                      <div className="pageTables-controls-title" style={{width: '66.66%'}}>
                        <div className="pageTables-title">
                            {msg.credits.title} <Currency value={amount} currency="CZK"/>
                        </div>
                      </div>
                      <div className="pageTables-controls-key">
                        <div className={`boxBtn color-white ${page < 1 ? 'disabled' : ''}`}
                             onClick={() => this.prevPage()}>
                            <ArrLeftButton/>
                        </div>
                      </div>
                      <div className="pageTables-controls-key">
                        <div className={`boxBtn color-white ${max <= limit || page === (Math.ceil(max / limit) - 1) ? 'disabled' : ''}`}
                             onClick={() => this.nextPage()}>
                            <ArrRightButton/>
                        </div>
                      </div>
                      <div className="pageTables-controls-key">
                        <div className="boxBtn color-white"
                             onClick={() => openCreditListUser(false)}>
                            <CloseButton/>
                        </div>
                      </div>
                    </div>
                    {habitues.map(hab =>
                      <div className="pageTables-key" key={`hab-${hab.get('id')}`}>
                        <div
                             onClick={() => this.doCredit(hab.get('id'))}
                             className={`boxBtn color-greenLight`}>
                            <div className="boxBtn-inner">
                                <span>
                                    {hab.get('fullName')}
                                </span>
                            </div>
                        </div>
                      </div>
                    )}

                </div>
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    limit: state.creditBill.get('limit'),
    page: state.creditBill.get('page'),
    max: state.creditBill.get('max'),
    habitues: state.creditBill.get('habitues'),
    tableToCredit: state.categories.get('tableToCredit'),
    tableToCreditAmount: state.categories.get('tableToCreditAmount'),
    tables: state.categories.get('tables'),
    barId: state.bars.getIn(['bar', 'id'])
}), {openCreditListUser, fetchHabitueList, cleanHabitueList, doCredit})(UsersPopup);



// WEBPACK FOOTER //
// ./src/browser/creditBill/UsersPopup.js